import React from 'react';
import { Button } from './Button';
export function PainPoints() {
  const points = ['Buscás material de educación financiera… y encontrás contenido genérico que no sirve para secundaria', 'Tenés que armar actividades desde cero porque no existe material completo y organizado', 'Tus alumnos viven rodeados de deudas, apuestas y dinero fácil… pero no sabés cómo llevarlo al aula', 'Las planificaciones y evaluaciones te consumen horas que no tenés', 'Querés dar clases más dinámicas y reales… pero no tenés el material estructurado'];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-138">
      <div className="max-w-3xl mx-auto" data-id="element-139">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-white leading-tight uppercase" data-id="element-140">
          ❌ ¿Te pasa esto?
        </h2>

        <div className="bg-brand-card border-l-4 border-red-500 p-4 md:p-6 rounded-r-lg mb-6 shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-141">
          <div className="space-y-3.5" data-id="element-142">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-143">
                <span className="text-red-500 mr-3 shrink-0 mt-0.5 text-base font-black" data-id="element-144">
                  ❌
                </span>
                <p className="text-sm md:text-base text-gray-200 font-bold leading-relaxed" data-id="element-145">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="w-full max-w-xl mx-auto" data-id="element-146">
          <Button className="text-sm md:text-base py-3 md:py-4 shadow-[0_0_30px_rgba(34,197,94,0.5)]" data-id="element-147">
            🔥 ¡QUIERO DEJAR DE IMPROVISAR Y TENER TODO RESUELTO! 🚀
          </Button>
          <p className="text-center text-yellow-300 font-black text-xs md:text-sm uppercase tracking-wider mt-3 animate-pulse" data-id="element-148">
            ¡ACCEDÉ AL KIT AHORA CON 75% OFF!
          </p>
        </div>
      </div>
    </section>;
}